import { useLang } from 'hooks/lang';

import { actions, projectStatusConfig } from 'entities';

import { useJustification } from 'providers/Justification';
import { useProjectProfile } from '../../context';
import { useToast } from 'providers/Toast';
import { useConfirmation } from 'providers/Confirmation';

import { MESSAGES } from '../../utils';

export function useProjectCancelation() {
  const { project, updateProject } = useProjectProfile();

  const { openJustificationModal } = useJustification();
  const { requestConfirmation } = useConfirmation();
  const { addToast } = useToast();

  const { t } = useLang();

  const cancelProject = actions.projects.cancelProject.use({
    onSuccess: () => {
      updateProject((old) => ({
        ...old,
        status: projectStatusConfig.canceled.code,
        canceledAt: new Date().toISOString(),
      }));
    },
  });

  const startCancelation = (extraParams: Record<string, string> = {}): void => {
    const cancel = (): void => addToast(MESSAGES.cancelProjectAborted(t));

    openJustificationModal({
      text: t('what-is-the-reason-for-cancelling-this-project-remember-this-cant-be-undone'),

      cancel,

      onConfirm: async (justification) =>
        requestConfirmation({
          cancel,
          type: 'irreversible',
          title: `${t('cancel-project')}?`,
          text: t('the-task-owners-will-be-notified-and-the-project-will-be-locked-for-any-change'),

          onConfirm: async () =>
            cancelProject.execute({
              project: project.id,
              justification,
              ...extraParams,
            }),
        }),
    });
  };

  return {
    startCancelation,
  };
}
